"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var utils_exports = {};
__export(utils_exports, {
  fetchSafe: () => fetchSafe,
  unwrapContentLength: () => unwrapContentLength,
  unwrapEtag: () => unwrapEtag,
  unwrapLastModified: () => unwrapLastModified
});
module.exports = __toCommonJS(utils_exports);
var import_retry = require("@hcengineering/retry");
var import_error = require("./error");
async function innerFetchSafe(url, init) {
  let response;
  try {
    response = await fetch(url, init);
  } catch (err) {
    console.error("network error", { err });
    throw new import_error.NetworkError(`Network error ${err}`);
  }
  if (response.ok) {
    return response;
  }
  if (response.status === 404) {
    return response;
  }
  const text = await response.text();
  throw new import_error.HulylakeError(text);
}
__name(innerFetchSafe, "innerFetchSafe");
async function fetchSafe(url, init, retryOptions) {
  if (retryOptions != null) {
    return await (0, import_retry.withRetry)(async () => await innerFetchSafe(url, init), retryOptions);
  }
  return await innerFetchSafe(url, init);
}
__name(fetchSafe, "fetchSafe");
function unwrapEtag(etag) {
  if (etag == null) {
    return void 0;
  }
  if (etag.startsWith("W/")) {
    etag = etag.substring(2);
  }
  if (etag.startsWith('"') && etag.endsWith('"')) {
    etag = etag.slice(1, -1);
  }
  return etag;
}
__name(unwrapEtag, "unwrapEtag");
function unwrapContentLength(length) {
  if (length == null) {
    return void 0;
  }
  return parseInt(length, 10);
}
__name(unwrapContentLength, "unwrapContentLength");
function unwrapLastModified(lastModified) {
  if (lastModified == null) {
    return void 0;
  }
  return Date.parse(lastModified);
}
__name(unwrapLastModified, "unwrapLastModified");
//# sourceMappingURL=utils.js.map
